import React from "react";
import { AiOutlineFundView } from "react-icons/ai";

export function Project(props: {
  url: string;
  img: string;
  github: string;
  description: string;
  languages: string[];
}) {
  return (
    <div
      className="Project"
      onClick={() => {
        window.open(props.github);
      }}
    >
      <img className="Project-img" src={props.img} alt="project" />
      <p className="github-view">
        <b>Click to view on github! </b>
      </p>
      <p className="Project-description">{props.description}</p>
      <div className="Project-languages">
        <p
          style={{
            marginRight: "0.5rem",
          }}
        >
          Languages:{" "}
        </p>
        {props.languages.map((language) => {
          return (
            <div className="Project-language">
              <p>{language}</p>
            </div>
          );
        })}
      </div>
      <div className="Project-buttons-list">
        <div style={{ cursor: props.url === "" ? "not-allowed" : "pointer" }}>
          <div
            className={
              "Project-button" + (props.url === "" ? " disabledbutton" : "")
            }
            onClick={() => {
              window.open(props.url);
            }}
          >
            <p>view</p>
            <AiOutlineFundView className="Project-icon" />
          </div>
        </div>
      </div>
    </div>
  );
}
